import { ExceptionModel } from 'web-pki';

export function isWebPKIError(error: unknown): error is ExceptionModel {
  return typeof error === 'object'
    && error !== null
    && 'userMessage' in error
    && 'message' in error
    && 'error' in error
    && 'origin' in error
    && 'code' in error;
}
